<template>
  <div id="main-wrapper">
    <Error />
    <b-overlay rounded="sm">
      <AgencyListener v-if="$auth.isAuthenticated && !$auth.loading" />
      <router-view />
      <modal-container />
      <AgencyVideoModalContainer v-if="$auth.isAuthenticated" />
      <ImageViewerModal v-if="$auth.isAuthenticated" />
      <!-- <GetSupport /> -->
      <PinnacleMapModal v-if="$auth.isAuthenticated && !$auth.loading" />
      <AgencySoundListener
        v-if="$auth.isAuthenticated && !$auth.loading && currentAgency && !isAgencyConnecting"
        :soundSettings="soundSelectorSetting"
        scope="user"
      />
    </b-overlay>
    <ConveyNotification />
  </div>
</template>

<script>
/* eslint-disable */
import AgencyListener from "./sockets/AgencyListener";
import Error from "./components/Error";
import ModalContainer from "./components/ModalContainer";
import AgencyVideoModalContainer from "./components/VideoModalContainer";
import ImageViewerModal from "./components/ImageViewerModal.vue";
import PageOverlay from "./components/PageOverlay";
// import GetSupport from "@/components/GetSupport";
import { mapActions, mapGetters, mapState } from "vuex";
import PinnacleMapModal from "@/components/PinnacleMapModal";
import AgencySoundListener from "@/components/AgencySoundListener";
import ConveyNotification from "@/components/ConveyNotification";

export default {
  components: {
    Error,
    AgencyListener,
    ModalContainer,
    AgencyVideoModalContainer,
    ImageViewerModal,
    PageOverlay,
    // GetSupport,
    PinnacleMapModal,
    AgencySoundListener,
    ConveyNotification
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId", "currentAgency", "isAgencyConnecting"]),
    ...mapGetters("user", ["isDarkMode", "currentSession", "isEmbedSDKLoaded", "soundSelectorSetting", "userTheme"]),
    ...mapState({
      currentUser: (state) => state.user.user
    }),
    fullyAuthenticated() {
      if (this.$auth.isAuthenticated && !this.$auth.loading) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      isMobileOrTabletDevice: false,
    }
  },
  created() {
    if (this.isDarkMode) {
      document.body.setAttribute('data-theme', 'dark')
    } else {
      document.body.removeAttribute('data-theme')
    }

    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.isMobileOrTabletDevice = true;
      this.$store.commit("user/setIsMobileDevice", true);
    }
    this.listenResizeEvent(null);
    window.addEventListener("resize", this.listenResizeEvent);
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", this.listenSystemThemeChange);
  },
  methods: {
    ...mapActions("conversations", ["unloadConversation"]),
    listenResizeEvent(e) {
      const { innerWidth, innerHeight } = window;
      if (!this.isMobileOrTabletDevice) {
        const isMobile = innerWidth < 768;
        this.$store.commit("user/setIsMobile", isMobile);
      } else {
        this.$store.commit("user/setIsMobile", true);
      }
      this.$store.commit("user/setViewport", { innerWidth, innerHeight });
    },
    listenSystemThemeChange(e) {
      if (this.userTheme === "system") {
        this.$store.commit("user/setIsDarkMode", e.matches);
        if (e.matches) {
          document.body.setAttribute('data-theme', 'dark')
        } else {
          document.body.removeAttribute('data-theme')
        }
      }
    },
  },
  watch: {
    "$route"(to, from) {
      if (from.name == "get-conversation") {
        this.unloadConversation();
      }
    },
    fullyAuthenticated(authenticated) {
      const className = `${document.body.className || ''}`;
      if (authenticated) {
        if (!className.includes('authenticated')) {
          setTimeout(() => {
            document.body.className = `${className} authenticated`;
          }, 5000);
        }
      } else {
        if (className.includes('authenticated')) {
          document.body.className = className.replace('authenticated', '');
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.listenResizeEvent);
    window.matchMedia('(prefers-color-scheme: dark)').removeEventListener("change", this.listenSystemThemeChange);

    if (this.isEmbedSDKLoaded) {
      this.$unloadScript(process.env.VUE_APP_CONVEY_SDK_URI)
        .then(() => {
          this.$store.commit("user/setIsEmbedSDKLoaded", false);
        })
        .catch(() => {
          this.$store.commit("user/setIsEmbedSDKLoaded", false);
        })
    }
  },
};
</script>

<style lang="scss">
@import '../vendor/css/style.css';
@import '../vendor/css/custom.scss';

body {
  height: 100vh;

  @supports (height: 100svh) {
    height: 100svh;
  }
}

html {
  height: 100vh;

  @supports (height: 100svh) {
    height: 100svh;
  }
}
</style>
